import type { Product } from '@scayle/storefront-nuxt'
import { getFirstAttributeValue } from '@scayle/storefront-nuxt'

export const sustainabilityAttributes = [
  'sustainability',
  'sustainabilityCertificates',
  'sustainabilityIcons',
  'sustainabilityMaterials',
]

export const isProductSustainable = (product: Product): boolean => {
  let isSustainable = false
  for (const attribute of sustainabilityAttributes) {
    if (getFirstAttributeValue(product.attributes, attribute)?.label) {
      isSustainable = true
      break
    }
  }
  return isSustainable
}
